<template>
  <div>
    <v-alert v-if="!state.id" type="info" dense text>Save the report to start its version history.</v-alert>
    <v-data-table v-else :headers="headers" :items="versions" :loading="loading" dense mobile-breakpoint="0" :items-per-page="25">
      <template v-slot:item.createdAt="{ item }">{{ new Date(item.createdAt).toLocaleString() }}</template>
      <template v-slot:item.actions="{ item }">
        <v-btn small text @click="load(item)">Load into editor</v-btn>
        <v-btn small text :disabled="item.version === current" @click="restore(item)">Restore (save as new version)</v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import { state } from './editorState'

export default {
  name: 'RbVersionsTab',
  props: { current: { type: Number, default: 0 } },
  data () {
    return {
      state, loading: false, versions: [],
      headers: [{ text: 'Version', value: 'version' }, { text: 'Note', value: 'label' }, { text: 'Saved', value: 'createdAt' }, { text: '', value: 'actions', sortable: false, align: 'end' }]
    }
  },
  computed: { ...mapGetters(['getEndpoint']) },
  async mounted () { await this.fetch() },
  methods: {
    async fetch () {
      if (!state.id) return
      this.loading = true
      try {
        const res = await axios.get(`${this.getEndpoint}/api/rb-builder/reports/${state.id}/versions`)
        this.versions = res.data.data
      } finally {
        this.loading = false
      }
    },
    async load (v) {
      const res = await axios.get(`${this.getEndpoint}/api/rb-builder/reports/${state.id}/versions/${v.version}`)
      state.tpl = res.data.data.template
      state.ctx = 'main'
      this.$emit('loaded', v.version)
    },
    async restore (v) {
      const res = await axios.post(`${this.getEndpoint}/api/rb-builder/reports/${state.id}/restore/${v.version}`, {})
      this.$snack(`Restored version ${v.version} as version ${res.data.data.version}.`, 'success')
      this.$emit('restored')
    }
  }
}
</script>
